module.exports = __webpack_public_path__ + "img/53.9bef5e05.svg";